import React from "react";
import { useNavigate } from "react-router-dom";
import { FiBell } from "react-icons/fi";
import Logo from "../assets/Elegho-Logo.png";
import { useSelector } from "react-redux";
import { appName } from "../../utils/constants";

function ContractorHeader() {
  const [unreadNotifications, setUnreadNotifications] = React.useState([]);
  const navigate = useNavigate();

  return (
    <div className="relative">
      <div className="w-full bg-white flex items-center justify-around gap-4 py-4">
        <div className="w-fit">
          <div className=" uppercase text-[#363062] font-bold text-xs shrink-0 w-fit">
            {appName}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-gray-600 text-[8px] italic font-medium ">
            Powered by
          </div>
          <div className="w-16 m-auto">
            <img src={Logo} alt="" />
          </div>
        </div>
      </div>
      <div
        className="absolute top-2 right-4 flex items-center"
        onClick={() => navigate("/notifications")}
      >
        <div className="flex items-center relative cursor-pointer">
          {unreadNotifications.length > 0 && (
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              {unreadNotifications.length}
            </div>
          )}
          <FiBell className="text-xl text-gray-500" />
        </div>
      </div>
    </div>
  );
}

export default ContractorHeader;
